import React from 'react';
import * as R from 'ramda';
import styles from './css/AllInvoices.scss';
import Card from '@mui/material/Card';
import CardHeaderCD from '../../component/CardHeaderCD';
import { store } from '../store';
import getHistoryListDefaultHOCEnhance from './../../main/HistoryListDefaultHOC';
import HistoryList from '../../main/HistoryList';
import { CardContent } from '@mui/material';
import { withProps } from 'react-recompose';
import ClientIcon from '@mui/icons-material/BusinessOutlined';

const ClientList = R.compose(
	getHistoryListDefaultHOCEnhance({
		store,
		method: 'GET',
		url: '/get/all/clients',
		options: { reactQuery: { queryName: 'getAllClients' } }
	}),
	withProps({
		onIcon: () => <ClientIcon />
	})
)(HistoryList);

const Clients = props => {
	return (
		<div className={styles.wrap}>
			<Card>
				<CardHeaderCD title="ALL CLIENTS" />
				<CardContent>
					<ClientList />
				</CardContent>
			</Card>
		</div>
	);
};
export default Clients;
